import { useAccount, useChainId } from 'wagmi'
import { useQuery } from '@tanstack/react-query'
import { ZERO_ADDRESS } from '@/web3/constants'
import { LotteryEntry } from '@/types/lottery'
import { useLottery } from '@/providers/BlockPotProvider'
import useLotteryRead from '../read/useLotteryRead'

export default function usePlayerEntries(roundIndex: number) {
    const chainId = useChainId()
    const { lotteryHash } = useLottery()
    const { address } = useAccount()
    const { game, selectedGame } = useLotteryRead()

    const { data } = useQuery({
        queryKey: ['playerEntries', selectedGame, chainId, address, lotteryHash, roundIndex],
        queryFn: async () => {
            const queryRoundIndex = roundIndex
            if (queryRoundIndex < 0) {
                return {
                    entries: []
                }
            }
            const entryIndexes = await game.entriesForPlayer([queryRoundIndex, address ?? ZERO_ADDRESS])
            const allEntries = await Promise.all(entryIndexes.map((index) => game.getEntry([index, queryRoundIndex])))
            const entries: LotteryEntry[] = entryIndexes.map((entryIndex, index) => ({
                index: entryIndex,
                beneficiary: allEntries[index].beneficiary,
                entryStart: allEntries[index].entryStart,
                amount: allEntries[index].amount,
                payoutInWeth: allEntries[index].payoutInWeth
            }))
            return {
                entries
            }
        },
        enabled: !!address
    })

    if (!data) {
        return undefined
    }

    return data
}